import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faUndo } from '@fortawesome/pro-solid-svg-icons/faUndo';
import type { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { ReactZoomPanPinchHandlers } from 'react-zoom-pan-pinch';

import { Button } from '@furality/furality-purpose';
import FontAwesomeIcon from '#/components/FontAwesomeIcon.tsx';

type MapButtonsProps = {
  zoomOut: ReactZoomPanPinchHandlers['zoomOut'];
  zoomIn: ReactZoomPanPinchHandlers['zoomIn'];
  resetTransform: ReactZoomPanPinchHandlers['resetTransform'];
  /**
   * When true, the close map button appears.
   */
  isMobileMapEnabled?: boolean;
  /**
   * When the map is in mobile, the map has a toggle map button.
   */
  closeMap?: () => void;

  buttonPosition: 'dealers' | 'explore';
  fixed?: boolean;
} & ComponentProps<typeof Button>;

/**
 * Map Control buttons!
 *
 * This component needs to be inside a position: relative element to render in the correct spot.
 */
const MapButtons: FC<MapButtonsProps> = ({
  zoomOut,
  zoomIn,
  resetTransform,
  closeMap,
  isMobileMapEnabled,
  buttonPosition,
  fixed,
  ...props
}) => {
  const { t } = useTranslation();
  const buttonPositionStyle =
    buttonPosition === 'dealers'
      ? {
          top: '10px',
          left: '10px',
        }
      : {
          top: '100px',
          right: '30px',
        };

  return (
    <>
      <div
        className="tools"
        style={{
          // TODO: className this
          position: fixed ? 'fixed' : 'absolute',
          zIndex: 9999,
          ...buttonPositionStyle,
        }}
      >
        <div className="d-flex flex-column">
          <Button
            variant="primary"
            size="sm"
            className="rounded-circle m-1"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => zoomIn()}
            {...props}
          />
          <Button
            variant="primary"
            size="sm"
            className="rounded-circle m-1"
            icon={<FontAwesomeIcon icon={faMinus} />}
            onClick={() => zoomOut()}
            {...props}
          />
          <Button
            variant="primary"
            size="sm"
            className="rounded-circle m-1"
            onClick={() => resetTransform()}
            icon={<FontAwesomeIcon icon={faUndo} />}
            {...props}
          />
        </div>
      </div>
      {isMobileMapEnabled && (
        <div style={{ position: 'absolute', top: '10px', right: '10px', zIndex: '100' }}>
          <Button
            variant="secondary"
            size="xl"
            icon={<FontAwesomeIcon icon={faTimes} />}
            className="rounded-circle btn-sm m-1"
            onClick={() => closeMap?.()}
            data-toggle="tooltip"
            title={t('shared.close')}
          />
        </div>
      )}
    </>
  );
};

export default MapButtons;
